module.exports = __webpack_public_path__ + "media/application/images/ui/join-home-star-0e9f3c826b2c244c071e69c6a1a6691f.jpg";